import LoggerService,{formatTrace} from '../../services/LoggerService';
import INITIAL_STATE from './INITIAL_STATE';
import REDUCER_ACTIONS from './ACTIONS';

const LOG = LoggerService.getInstance();

const reducer = (
  state: any,
  action: any
) => {
	if (action.type === REDUCER_ACTIONS.SET_CURRENT_STEP) {
		const {currentStep} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_CURRENT_STEP',{currentStep}));
		return {...state,currentStep};
	}
	if (action.type === REDUCER_ACTIONS.SET_FROM_DATE) {
		const {from_date} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_FROM_DATE',{from_date}));
		return {...state,from_date};
	}
	if (action.type === REDUCER_ACTIONS.SET_FROM_DATE_END) {
		const {from_date_end} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_FROM_DATE_END',{from_date_end}));
		return {...state,from_date_end};
	}
	if (action.type === REDUCER_ACTIONS.SET_TO_DATE) {
		const {to_date} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_TO_DATE',{to_date}));
		return {...state,to_date};
	}
	if (action.type === REDUCER_ACTIONS.SET_TO_DATE_END) {
		const {to_date_end} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_TO_DATE_END',{to_date_end}));
		return {...state,to_date_end};
	}
	if (action.type === REDUCER_ACTIONS.SET_ACTIVITY_TYPES) {
		const {activity_types} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_ACTIVITY_TYPES',{activity_types}));
		return {...state,activity_types};
	}
	if (action.type === REDUCER_ACTIONS.SET_DIRECTIONS_OPS) {
		const {directions_ops} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_DIRECTIONS_OPS',{directions_ops}));
		return {...state,directions_ops};
	}
	if (action.type === REDUCER_ACTIONS.SET_HUBS_OPS) {
		const {hubs_ops} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_HUBS_OPS',{hubs_ops}));
		return {...state,hubs_ops};
	}
	if (action.type === REDUCER_ACTIONS.SET_COLLABORATORS) {
		const {collaborators} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_COLLABORATORS',{collaborators}));
		return {...state,collaborators};
	}
	// if (action.type === REDUCER_ACTIONS.SET_REFERENTIAL_CUSTOMERS) {
	// 	const {referential_customers} = action.payload;
  //   LOG.trace(...formatTrace('reducer - SET_REFERENTIAL_CUSTOMERS',{referential_customers}));
	// 	return {...state,referential_customers};
	// }
	if (action.type === REDUCER_ACTIONS.SET_AUDITED_CUSTOMERS) {
		const {audited_customers} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_AUDITED_CUSTOMERS',{audited_customers}));
		return {...state,audited_customers};
	}
	if (action.type === REDUCER_ACTIONS.SET_REFERENTIALS) {
		const {referentials} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_REFERENTIALS',{referentials}));
		return {...state,referentials};
	}
	if (action.type === REDUCER_ACTIONS.SET_CHARGES_ID_SELECTED) {
		const {chargesIdSelected} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_CHARGES_ID_SELECTED',{chargesIdSelected}));
		return {...state,chargesIdSelected};
	}
	if (action.type === REDUCER_ACTIONS.SET_CHARGES_SELECTED) {
		const {chargesSelected} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_CHARGES_SELECTED',{chargesSelected}));
		return {...state,chargesSelected};
	}
	if (action.type === REDUCER_ACTIONS.SET_OPTIONS_FROM_DATE) {
		const {optionsFromDate} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_OPTIONS_FROM_DATE',{optionsFromDate}));
		return {...state,optionsFromDate};
	}
	if (action.type === REDUCER_ACTIONS.SET_OPTIONS_VOLUME_CHANGE) {
		const {optionsVolumeChoice} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_OPTIONS_VOLUME_CHANGE',{optionsVolumeChoice}));
		return {...state,optionsVolumeChoice};
	}
	if (action.type === REDUCER_ACTIONS.SET_OPTIONS_VOLUME_RATIO) {
		const {optionsVolumeRatio} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_OPTIONS_VOLUME_RATIO',{optionsVolumeRatio}));
		return {...state,optionsVolumeRatio};
	}
	if (action.type === REDUCER_ACTIONS.SET_OPTIONS_KEEP_ACTIVITIES) {
		const {optionsKeepActivities} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_OPTIONS_KEEP_ACTIVITIES',{optionsKeepActivities}));
		return {...state,optionsKeepActivities};
	}
	if (action.type === REDUCER_ACTIONS.SET_OPTIONS_KEEP_COLLABORATOR) {
		const {optionsKeepCollaborator} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_OPTIONS_KEEP_COLLABORATOR',{optionsKeepCollaborator}));
		return {...state,optionsKeepCollaborator};
	}
	// return state;
	throw new Error(`No matching "${action.type}" action type`);
};

export {INITIAL_STATE};
export default reducer;
